export { default as CompactRatio } from './CompactRatio';
